import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { AppRoutes } from './routes/AppRoutes'
import { ErrorBoundary } from './components/ErrorBoundary'
import { LocaleSync } from './components/LocaleSync'
import { FieldTextSizeSync } from './components/FieldTextSizeSync'
import { useOfflinePhotoSync } from './hooks/useOfflinePhotoSync'

function AppSyncEffects() {
  useOfflinePhotoSync()
  return (
    <>
      <LocaleSync />
      <FieldTextSizeSync />
    </>
  )
}

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <AppSyncEffects />
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default App
